import React, { useContext, useEffect } from "react";
import FormContext, { RegistrationFormContextShape } from "../contexts/form";
import { useNavigate } from "react-router-dom";
import { PAGE_PATHS } from "./page-paths";

export default function OnboardingSuccess() {
  const { setFieldValue, getFieldValue } = useContext(
    FormContext
  ) as RegistrationFormContextShape;

  const navigate = useNavigate();

  useEffect(() => {
    setFieldValue("isSuccessful", true);
    navigate(
      getFieldValue("signupType") === "assisted"
        ? PAGE_PATHS.SIGNUP
        : PAGE_PATHS.SIGNUP_SELF
    );
  }, []);

  return <></>;
}
